import React from "react";
import { sanitizeRichText } from "../../utils/richText";

const RichTextContent = ({ html, className = "" }) => (
  <div
    className={`prose prose-sm max-w-none whitespace-pre-wrap ${className}`}
    dangerouslySetInnerHTML={{ __html: sanitizeRichText(html || "") }}
  />
);

export default RichTextContent;
